import DashboardCard from '@Components/DashboardCard';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { selectUser } from '@Store/slices/auth/selectors';
import DashboardPayments from '@Components/dashboard-payments/DashboardPayments.Container';
import MonthlyTransactionsChart from '@Components/dashboard-charts/MonthlyTransactionsChart';
import { useTranslation } from 'providers/CultureProvider';

const Dashboard: React.FC = () => {
  const user = useSelector(selectUser);
  const { t } = useTranslation();

  return (
    <>
      <Box my={7.5} px={3.75} width='100%'>
        <Typography fontSize={34} fontWeight={700} variant='h2'>
          {t('Welcome Back')}
        </Typography>
        <Typography fontSize={16} variant='subtitle1'>
          {user?.email}!
        </Typography>
      </Box>

      {/* Top Row - Stats Cards */}
      <Box display={'flex'} gap={3.75} px={3.75} width='100%'>
        <DashboardCard
          title={t('New Users')}
          url='api/Users/GetNewUsersCount'
          to='/users'
        />
        <DashboardCard
          title={t('Parking Sessions')}
          url='api/Sessions/GetNewSessionsCount'
          to='/sessions'
        />
      </Box>

      {/* Middle Row - Transactions Chart */}
      <Box my={4.5} px={3.75} width='100%'>
        <MonthlyTransactionsChart />
      </Box>

      {/* Bottom Row - Payments */}
      <Box my={4.5} px={3.75} width='100%'>
        <DashboardPayments />
      </Box>
    </>
  );
};

export default Dashboard;